import ApiClient from 'services/ApiClient';

import { IFeaturesResponse } from 'types/features';

class FeaturesApi {
    getFeatures = async <Response = IFeaturesResponse>(): Promise<Partial<Response> | unknown> => {
        return await ApiClient.private.get<Response>('workout-service/subscriptions/v1/user/features/');
    };
}

export default FeaturesApi;
